export default __webpack_public_path__ + "43c149fcc4cd40bc87e7db7571f0f026.png";